import { createContext } from 'react';
import { SnackbarContextData } from './interfaces/snackbar-context-props.interface';

const SnackbarContext = createContext<SnackbarContextData>(
    {} as SnackbarContextData,
);

export default SnackbarContext;
